import type { Tag, Workspace } from '@carboncopyco/types';
import { WorkspaceManageTagProvider } from './WorkspaceManageTagContext';
import { WorkspaceManageTagModalBody } from './WorkspaceManageTagModalBody';

type WorkspaceManageTagModalProps = {
  organizationId: string;
  workspace: Workspace;
  onClose: (tagIds: Tag['id'][]) => void;
  isOpen?: boolean;
};

export const WorkspaceManageTagModal = ({
  organizationId,
  workspace,
  onClose,
  isOpen,
}: WorkspaceManageTagModalProps) => {
  return (
    <WorkspaceManageTagProvider
      workspace={workspace}
      organizationId={organizationId}
      isOpen={isOpen}
      onClose={onClose}
    >
      <WorkspaceManageTagModalBody />
    </WorkspaceManageTagProvider>
  );
};
